(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      document.querySelectorAll('[data-cart-drawer-trigger]').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });
      this.querySelectorAll('[data-cart-drawer-close]').forEach((el) => {
        el.addEventListener('click', () => this.dialog.close());
      });
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });
      const params = new URLSearchParams(window.location.search);
      if (params.get('cart') === 'open') {
        params.delete('cart');
        const query = params.toString();
        const clean = window.location.pathname + (query ? '?' + query : '');
        window.history.replaceState({}, '', clean);
        this.open();
      }
    }
    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  // Apply a discount code via Shopify's /discount/CODE endpoint, returning to this page.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-cart-discount]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('input[name="discount"]');
    const code = input ? input.value.trim() : '';
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname + '?cart=open');
  });

  // Cap cart quantities to available stock. Inputs for inventory-tracked,
  // no-oversell items carry data-stock. On change, clamp the value to the max
  // and reveal an "Only N in stock" note instead of letting the update fail.
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || el.nodeName !== 'INPUT' || !el.hasAttribute('data-stock')) return;
    var max = parseInt(el.getAttribute('data-stock'), 10);
    var val = parseInt(el.value, 10);
    if (isNaN(max)) return;
    var note = el.parentElement ? el.parentElement.querySelector('[data-qty-note]') : null;
    if (!isNaN(val) && val > max) {
      el.value = max;
      if (note) note.hidden = false;
    } else if (note) {
      note.hidden = true;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    class CartRecos extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cyo-track]');
      this.prev = this.querySelector('[data-cyo-prev]');
      this.next = this.querySelector('[data-cyo-next]');
      this.url = this.dataset.url;
      if (!this.track || !this.url || this.dataset.loaded) return;
      // Lazy-load: fetch when the drawer opens (watch the dialog's `open` attr).
      // Can't use IntersectionObserver here because the element starts `hidden`
      // (display:none), which never intersects.
      const dialog = this.closest('dialog');
      if (!dialog || dialog.open) {
        this.load();
        return;
      }
      this._mo = new MutationObserver(() => {
        if (dialog.open) {
          this._mo.disconnect();
          this.load();
        }
      });
      this._mo.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }
    load() {
      this.dataset.loaded = '1';
      fetch(this.url)
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const cards = doc.querySelector('[data-cyo-cards]');
          if (!cards || !cards.children.length) return;
          this.track.innerHTML = cards.innerHTML;
          // Point each quick-add back to the current page so the drawer reopens.
          const back = window.location.pathname + '?cart=open';
          this.track.querySelectorAll('form').forEach((f) => {
            let rt = f.querySelector('input[name="return_to"]');
            if (!rt) {
              rt = document.createElement('input');
              rt.type = 'hidden';
              rt.name = 'return_to';
              f.appendChild(rt);
            }
            rt.value = back;
          });
          this.hidden = false;
          this.setupArrows();
        })
        .catch(() => {});
    }
    setupArrows() {
      if (!this.prev || !this.next) return;
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        const overflowing = this.track.scrollWidth > this.track.clientWidth + 2;
        this.prev.hidden = !overflowing || this.track.scrollLeft <= 0;
        this.next.hidden = !overflowing || this.track.scrollLeft >= max;
      };
      this.prev.addEventListener('click', () => this.track.scrollBy({ left: -220, behavior: 'smooth' }));
      this.next.addEventListener('click', () => this.track.scrollBy({ left: 220, behavior: 'smooth' }));
      this.track.addEventListener('scroll', update, { passive: true });
      update();
    }
  }
  if (!customElements.get('cart-recos')) customElements.define('cart-recos', CartRecos);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-drawer"] && !Shopify.designMode) return;
  try {
    class FilterDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-fd-panel]');
      if (!this.panel) return;
      this.triggers = Array.from(this.querySelectorAll('[data-fd-trigger]'));
      if (this.id) {
        this.triggers = this.triggers.concat(
          Array.from(document.querySelectorAll('[data-fd-trigger-for="' + this.id + '"]'))
        );
      }
      if (!this.triggers.length) return;
      this.onKey = (e) => { if (e.key === 'Escape') this.close(); };
      this.triggers.forEach((t) => t.addEventListener('click', () => this.open()));
      this.querySelectorAll('[data-fd-close], [data-fd-overlay]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
    }
    open() {
      this.classList.add('is-open');
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
      const close = this.panel.querySelector('[data-fd-close]');
      if (close) close.focus();
    }
    close() {
      this.classList.remove('is-open');
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
      if (this.triggers[0]) this.triggers[0].focus();
    }
  }
  if (!customElements.get('filter-drawer')) customElements.define('filter-drawer', FilterDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-predictive-input]');
      this.panel = this.querySelector('[data-predictive-results]');
      this.url = this.dataset.url;
      this.searchUrl = this.dataset.searchUrl;
      this.view = this.dataset.view;
      if (!this.input || !this.panel || !this.url) return;
      this.options = [];
      this.active = -1;
      this.timer = null;
      this.controller = null;
      this.cache = new Map();
      this.money = this.moneyFormatter();
      this.onInput = this.onInput.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('keydown', this.onKeydown);
      this.input.addEventListener('focus', () => {
        if (this.options.length && this.input.value.trim().length >= 2) this.open();
      });
      document.addEventListener('click', this.onDocClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }
    moneyFormatter() {
      const currency = this.dataset.currency || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
      } catch (e) {
        return { format: (n) => currency + ' ' + Number(n).toFixed(2) };
      }
    }
    onInput() {
      const q = this.input.value.trim();
      clearTimeout(this.timer);
      if (q.length < 2) { this.clear(); this.close(); return; }
      this.timer = setTimeout(() => this.fetch(q), 200);
    }
    async fetch(q) {
      if (this.cache.has(q)) { this.render(q, this.cache.get(q)); return; }
      const url = this.url + '.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=8'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      try {
        const res = await fetch(url, { signal: this.controller.signal });
        if (!res.ok) return;
        const data = await res.json();
        const products = (((data.resources || {}).results || {}).products) || [];
        this.cache.set(q, products);
        if (this.input.value.trim() === q) this.render(q, products);
      } catch (e) { /* aborted or network error - keep prior results */ }
    }
    thumb(product) {
      const raw = (product.featured_image && product.featured_image.url) || product.image;
      if (!raw) return null;
      try { const u = new URL(raw, window.location.origin); u.searchParams.set('width', '120'); return u.href; }
      catch (e) { return raw; }
    }
    viewAllLink(q) {
      const all = document.createElement('a');
      all.className = 'pquick__all';
      all.tabIndex = -1;
      all.href = this.searchUrl + '?q=' + encodeURIComponent(q) + (this.view ? '&view=' + encodeURIComponent(this.view) : '');
      all.textContent = (this.dataset.viewAll || 'View all results for %TERMS%').replace('%TERMS%', q);
      return all;
    }
    render(q, products) {
      this.clear();
      if (!products.length) {
        const empty = document.createElement('p');
        empty.className = 'pquick__empty';
        empty.textContent = (this.dataset.noResults || 'No matches for %TERMS%').replace('%TERMS%', q);
        this.panel.appendChild(empty);
        this.panel.appendChild(this.viewAllLink(q));
        this.options = [];
        this.open();
        return;
      }
      const id = this.input.getAttribute('aria-controls');
      products.forEach((p, i) => {
        const row = document.createElement('a');
        row.className = 'pquick__link';
        row.setAttribute('role', 'option');
        row.id = id + '-opt-' + i;
        row.setAttribute('aria-selected', 'false');
        row.href = p.url;
        row.tabIndex = -1;

        const thumb = document.createElement('span');
        thumb.className = 'pquick__thumb';
        const src = this.thumb(p);
        if (src) {
          const img = document.createElement('img');
          img.src = src; img.alt = ''; img.loading = 'lazy';
          thumb.appendChild(img);
        }
        row.appendChild(thumb);

        const text = document.createElement('span');
        text.className = 'pquick__text';
        const name = document.createElement('span');
        name.className = 'pquick__name';
        name.textContent = p.title;
        text.appendChild(name);
        const metaParts = [p.vendor, p.type].filter(Boolean);
        if (metaParts.length) {
          const meta = document.createElement('span');
          meta.className = 'pquick__meta';
          meta.textContent = metaParts.join(' · ');
          text.appendChild(meta);
        }
        row.appendChild(text);

        const price = document.createElement('span');
        price.className = 'pquick__price';
        price.textContent = this.money.format(parseFloat(p.price));
        row.appendChild(price);

        this.panel.appendChild(row);
      });

      this.panel.appendChild(this.viewAllLink(q));

      this.options = Array.from(this.panel.querySelectorAll('[role="option"]'));
      this.active = -1;
      this.open();
    }
    clear() {
      this.panel.innerHTML = '';
      this.options = [];
      this.active = -1;
    }
    open() {
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }
    close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.setActive(-1);
    }
    setActive(index) {
      this.options.forEach((o, i) => o.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      this.active = index;
      const opt = this.options[index];
      if (opt) {
        this.input.setAttribute('aria-activedescendant', opt.id);
        opt.scrollIntoView({ block: 'nearest' });
      } else {
        this.input.removeAttribute('aria-activedescendant');
      }
    }
    onKeydown(event) {
      if (this.panel.hidden || !this.options.length) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.setActive((this.active + 1) % this.options.length);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.setActive((this.active - 1 + this.options.length) % this.options.length);
      } else if (event.key === 'Enter') {
        const opt = this.options[this.active];
        if (opt) { event.preventDefault(); window.location.href = opt.href; }
      } else if (event.key === 'Escape') {
        this.close();
      }
    }
    onDocClick(event) {
      if (!this.contains(event.target)) this.close();
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-recs-embed"] && !Shopify.designMode) return;
  try {
    class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const inner = doc.querySelector('.prec__inner');
          if (inner) this.innerHTML = inner.outerHTML;
          this.dataset.loaded = '1';
        })
        .catch(() => {});
    }
  }
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.realBtn = document.querySelector('.buy-buttons__atc');
      this.addBtn = this.querySelector('[data-satc-add]');
      this.priceOut = this.querySelector('[data-satc-price]');
      this.mq = window.matchMedia('(max-width: 749px)');
      if (!this.realBtn) return;
      if (this.addBtn) {
        this.addBtn.addEventListener('click', () => { this.realBtn.click(); });
      }
      this.priceSrc = document.querySelector('.buy-buttons__price') || document.querySelector('.price__current');
      if (this.priceSrc && this.priceOut) {
        this._syncPrice();
        this._pobs = new MutationObserver(() => this._syncPrice());
        this._pobs.observe(this.priceSrc, { childList: true, subtree: true, characterData: true });
      }
      this._io = new IntersectionObserver((entries) => {
        const e = entries[0];
        const show = this.mq.matches && !e.isIntersecting;
        this.classList.toggle('is-visible', show);
      }, { threshold: 0 });
      this._io.observe(this.realBtn);
      this._onMq = () => { if (!this.mq.matches) this.classList.remove('is-visible'); };
      this.mq.addEventListener('change', this._onMq);
    }
    _syncPrice() {
      const m = (this.priceSrc.textContent || '').match(/[^0-9.,]*[0-9][0-9.,]*/);
      const money = (this.priceSrc.textContent || '').match(/[\p{Sc}$£€¥]?\s?[0-9][0-9.,]*/u);
      if (money) this.priceOut.textContent = money[0].trim();
    }
    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._pobs) this._pobs.disconnect();
      if (this._onMq) this.mq.removeEventListener('change', this._onMq);
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
  } catch(e) { console.error(e); }
})();

})();
